import {DeliveryOption} from '@wix/delivery-section-cart/types';

export class DeliverySectionOptionModel {
  public id: string;
  public value: string;
  public subtitle: string;
  public isSelectable: boolean;
  public isPartial: boolean;

  constructor(option: DeliveryOption) {
    this.id = option.options[0]?.id;
    this.value = option.title;
    this.subtitle = option.subtitle;
    this.isSelectable = true;
    this.isPartial = option.partial;
  }
}
